import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Project, ProjectClient } from '@/server/MakeSenseApp-backend'
import { onMounted, ref, watch } from 'vue'
import { useProjectStore } from '@/stores/ProjectStore'
import SingleSelectComponent from '../general/select/SingleSelectComponent.vue'
import { requiredInject } from '@/utilities/requiredInject'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectSelector',
  setup(__props) {

let projects = ref<Array<Project>>([])
let selectedProject = ref<{ value: string; text: string } | null>(null)

let store = useProjectStore()
const projectClient = requiredInject<ProjectClient>('ProjectClient')

watch(selectedProject, (newValue) => {
  if (newValue !== null) {
    store.setProject(projects.value.find((x) => x.id === newValue!.value))
    sessionStorage.setItem('selectedProject', JSON.stringify(newValue)) // Save in session storage
  }
})

onMounted(() => {
  watch(
    () => store.refreshCounter,
    () => {
      projectClient
        .getProjects()
        .then((data) => {
          projects.value = data

          const savedProject = sessionStorage.getItem('selectedProject')
          const parsedProject = savedProject ? JSON.parse(savedProject) : null

          if (parsedProject && data.some((p) => p.id === parsedProject.value)) {
            selectedProject.value = parsedProject // Restore previous selection if valid
          } else if (data.length > 0 && data[0].id) {
            selectedProject.value = {
              value: data[0].id,
              text: data[0].name!
            }
          } else {
            selectedProject.value = null
            store.setNoProjects()
          }
        })
        .catch((reason: any) => {
          if (reason.status === 403) {
            store.setNoProjects()
          } else {
            throw reason
          }
        })
    },
    { immediate: true }
  )
})

return (_ctx: any,_cache: any) => {
  return (_unref(projects) && _unref(selectedProject))
    ? (_openBlock(), _createBlock(SingleSelectComponent, {
        key: 0,
        "model-value": _unref(selectedProject),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedProject) ? (selectedProject).value = $event : selectedProject = $event)),
        "options-single": 
      _unref(projects).map((project) => ({ value: project.id ?? '', text: project.name ?? '' }))
    ,
        "select-text": "Select project"
      }, null, 8, ["model-value", "options-single"]))
    : _createCommentVNode("", true)
}
}

})